import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { usePageMeta } from "../lib/seo";
import { Hero } from "../components/Hero";
import { MarqueeStrip } from "../components/Marquee";
import { About } from "../components/About";
import { Konfigurator } from "../components/Konfigurator";
import { Services } from "../components/Services";
import { Software } from "../components/Software";
import { Results } from "../components/Results";
import { Gallery } from "../components/Gallery";
import { Faq } from "../components/Faq";
import { Contact } from "../components/Contact";

export default function Landing() {
  usePageMeta("ECU SOLUTIONS | Chiptuning & Steuergeräte-Lösungen", "/");
  return (
    <div className="relative bg-brand-dark min-h-screen">
      <Header />
      <main>
        <Hero />
        <MarqueeStrip />
        <About />
        <Konfigurator />
        <Services />
        <Software />
        <Results />
        <Gallery />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
